//internalPageSLice
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  sector: "",
  country: "",
  variety: "",
  flashColor: "",
  ipOwnerShip: "",
  favourite: 1,
  favourites: [],
  selectedAction: null,
  internalPageHeader: null,
  fetchFavourite: false,
  routes: "",
  pages: {}, // 🔹 all internal page data keyed by slug
  selectedPage: null,
};

const internalPageSlice = createSlice({
  name: "internalPage",
  initialState,
  reducers: {
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setSector: (state, action) => {
      state.sector = action.payload;
    },
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setVariety: (state, action) => {
      state.variety = action.payload;
    },
    setFavourite: (state, action) => {
      state.favourite = action.payload;
    },
    setFlashColor: (state, action) => {
      state.flashColor = action.payload;
    },
    setIpOwnerShip: (state, action) => {
      state.ipOwnerShip = action.payload;
    },
    setFavourites: (state, action) => {
      state.favourites = action.payload;
    },
    setInternalPageHeader: (state, action) => {
      state.internalPageHeader = action.payload;
    },
    setFetchFavourtie: (state, action) => {
      state.fetchFavourite = action.payload;
    },
    setSpecialProject: (state, action) => {
      state.specialProject = action.payload;
    },
    setPageData: (state, action) => {
      const { slug, data } = action.payload;

      state.pages[slug] = data;
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    favouriteSelector: (state, action) => {
      const { page, contentId, slug, contentType } = action.payload;
      // contentType should be "Documents" | "Links" | "Videos"

      const contentKeyMap = {
        Documents: "documents",
        Links: "links",
        Videos: "videos",
      };

      const contentKey = contentKeyMap[contentType];
      if (!contentKey) return state; // invalid type

      const updatedSections = page?.internalPageSections.map((section) => {
        const updatedItems = section[contentKey]?.map((item) =>
          item.id === contentId ? { ...item, favorite: !item.favorite } : item
        );

        return {
          ...section,
          [contentKey]: updatedItems,
        };
      });

      return {
        ...state,
        pages: {
          ...state.pages,
          [slug]: {
            ...page,
            internalPageSections: updatedSections,
          },
        },
      };
    },
  },
});
export const {
  setSearch,
  setSector,
  setCountry,
  setVariety,
  setFavourite,
  setFlashColor,
  setIpOwnerShip,
  setFavourites,
  setInternalPageHeader,
  setFetchFavourtie,
  setRoutes,
  setSpecialProject,
  setCropTrak,
  setPageData,
  setSelectedPage,
  favouriteSelector,
} = internalPageSlice.actions;
export default internalPageSlice.reducer;
